export const SHARE = 'MODAL_TYPE_SHARE';
export const LIKE = 'LIKE';
export const COMMENT = 'COMMENT';
export const ADD_FRIEND = 'ADD_FRIEND';
export const PROFILE_IMAGE = 'PROFILE_IMAGE';


// WEBPACK FOOTER //
// ./src/constants/ModalTypes.js